import * as types from './types';

const initialState = {
  FeedbackData: []
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case types.POST_FEEDBACK_SUCCESS: {
      return {
        ...state,
        FeedbackData: action.payload
      };
    }
    case types.POST_FEEDBACK_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
